import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["UNSAFE_inputProps", "inputProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { branch, compose, defaultProps, withProps, mapProps } from 'recompose';
import { setPropTypes, PropTypes } from 'proper-types';
import { withUncontrolledProp, withUniqueFormIdentifier } from '@klarna/higher-order-components';
import withAutofillProps from '@bubble-ui/hoc-with-autofill-props';
import wrapInteractiveComponent from '@bubble-ui/hoc-wrap-interactive-component';
import reformatObfuscation from '@bubble-ui/util-reformat-obfuscation';
import withOnEnterAndOnTab from '@bubble-ui/hoc-with-on-enter-and-on-tab';
import withPropDeprecationWarning from '@bubble-ui/hoc-with-prop-deprecation-warning';
export default compose(setPropTypes({
  arrow: PropTypes.oneOf(['top-left', 'top', 'top-right', 'right-top', 'right', 'right-bottom', 'bottom-left', 'bottom', 'bottom-right', 'left-top', 'left', 'left-bottom']),
  autofill: PropTypes.bool,
  big: PropTypes.bool,
  darkBackground: PropTypes.bool,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  fieldLink: PropTypes.string,
  fieldLinkAriaLabel: PropTypes.string,
  fieldLinkDisabled: PropTypes.bool,
  fieldLinkRole: PropTypes.string,
  fieldTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  fieldTooltipAriaLabel: PropTypes.string,
  fieldTooltipDoNotFold: PropTypes.bool,
  fieldTooltipFluidWidth: PropTypes.bool,
  onFieldTooltipClick: PropTypes.func,
  forceControlled: PropTypes.bool,
  hasDegradedPerformance: PropTypes.bool,
  icon: PropTypes.node,
  iconTooltip: PropTypes.func,
  id: PropTypes.string,
  keyboardType: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  mouseflowExclude: PropTypes.bool,
  obfuscatedValue: PropTypes.string,
  onAutofill: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onComponentRef: PropTypes.func,
  onDisabledClick: PropTypes.func,
  onEndAutofill: PropTypes.func,
  onEnter: PropTypes.func,
  onFieldLinkClick: PropTypes.func,
  onFocus: PropTypes.func,
  onTab: PropTypes.func,
  readOnly: PropTypes.bool,
  testID: PropTypes.string,
  tooltipActive: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'checkbox', 'color', 'date', 'datetime-local', 'email', 'file', 'hidden', 'image', 'month', 'number', 'password', 'radio', 'range', 'reset', 'search', 'submit', 'tel', 'text', 'time', 'url', 'week']),
  UNSAFE_inputProps: PropTypes.object,
  value: PropTypes.string,
  warning: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
}), withUniqueFormIdentifier, withAutofillProps({
  autofill: true
}), branch(function (_ref) {
  var forceControlled = _ref.forceControlled;
  return !forceControlled;
}, withUncontrolledProp({
  prop: 'value',
  defaultProp: 'defaultValue',
  handlers: {
    onChange: function onChange() {
      return function (value) {
        return value;
      };
    }
  }
}), function (x) {
  return x;
}), withProps(function (_ref2) {
  var error = _ref2.error,
      hasDegradedPerformance = _ref2.hasDegradedPerformance,
      label = _ref2.label,
      value = _ref2.value,
      warning = _ref2.warning,
      obfuscatedValue = _ref2.obfuscatedValue;
  return {
    hasLabel: label && label.length > 0,
    hasValue: value && value.length > 0,
    error: Boolean(error),
    warning: Boolean(warning),
    obfuscatedValue: hasDegradedPerformance ? obfuscatedValue : reformatObfuscation(obfuscatedValue)
  };
}), branch(function (_ref3) {
  var hasDegradedPerformance = _ref3.hasDegradedPerformance;
  return !hasDegradedPerformance;
}, wrapInteractiveComponent({
  keyboardFocus: false
}), function (x) {
  return x;
}), defaultProps({
  value: '',
  mouseflowExclude: false,
  position: 'standalone',
  onKeyDown: function onKeyDown() {},
  onTab: function onTab() {},
  onEnter: function onEnter() {}
}), withOnEnterAndOnTab, mapProps(function (_ref4) {
  var UNSAFE_inputProps = _ref4.UNSAFE_inputProps,
      inputProps = _ref4.inputProps,
      rest = _objectWithoutProperties(_ref4, _excluded);

  return _objectSpread({
    UNSAFE_inputProps: inputProps || UNSAFE_inputProps
  }, rest);
}), withProps(function (_ref5) {
  var id = _ref5.id;
  return {
    ids: id ? {
      root: "".concat(id, "__root"),
      container: "".concat(id, "__container"),
      icon: "".concat(id, "__icon"),
      textWrapper: "".concat(id, "__text-wrapper"),
      label: "".concat(id, "__label"),
      input: id,
      loader: "".concat(id, "__loader"),
      obfuscatedValue: "".concat(id, "__obfuscated-value"),
      fieldLinkWrapper: "".concat(id, "__field-link-wrapper"),
      fieldLink: "".concat(id, "__field-link"),
      fieldTooltip: "".concat(id, "__field-tooltip")
    } : {}
  };
}), withPropDeprecationWarning({
  name: 'big',
  removalDate: 'Q1 2022'
}), withPropDeprecationWarning({
  name: 'fieldTooltipDoNotFold',
  removalDate: 'v5.0.0'
}));
//# sourceMappingURL=index.js.map